import { CalendarOutlined, ControlOutlined, RobotOutlined } from '@ant-design/icons';
import { Card, Col } from 'antd';
import moment from 'moment';
import React from 'react';
import { shallowEqual } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../../store';
import { MATURITY_LATE_DAY } from '../../../../store/interestFormOptions';
import { BLACK, RowMd } from '../../../../styles';
import Icon from '../../../../styles/Icon';
import { ANNOUNCEMENT, BALANCE } from '../../../../styles/iconTypes';
import { formatDate } from '../../../../utils/helpers/date';
import { ImpTypes, IMP_OCR } from '../impCommonData';

const ImpSumUpOpts = ({ impType }:{
  impType: ImpTypes
}) => {
  const { t } = useTranslation();

  const {
    legalBasis,
    factualBasis,
    endDate,
    maturityDateOpts,
    shouldAutoAssign,
  } = useTypedSelector(state =>
    impType === IMP_OCR ? state.impOcr : state.impExternal, shallowEqual);

  return (
    <RowMd
      style={{ width: '100%' }}
    >
      <Col span={24}>
        <Card
          style={{ width: '100%' }}
          title={t('ImpSumUpOpts.title')}
          bordered={false}
          extra={
            <ControlOutlined />
        }
        >
          <Card type="inner" title={t('ImpSumUpOpts.ending')} extra={<CalendarOutlined />}>
            {formatDate(endDate ?? moment())}
          </Card>
          <Card
            type="inner"
            title={t('ImpSumUpOpts.maturity')}
            extra={<CalendarOutlined />}
            style={{ marginTop:12 }}
          >
            {maturityDateOpts === MATURITY_LATE_DAY ?
              t('ImpSumUpOpts.matDesc1') :
              t('ImpSumUpOpts.matDesc2')}
          </Card>
          <Card
            type="inner"
            title={t('ImpSumUpOpts.legalBasis')}
            style={{ marginTop:12 }}
            extra={(
              <Icon
                iconType={BALANCE}
                height="18"
                width="18"
                fill={BLACK}
              />
)}
          >
            {legalBasis ?? t('NoData')}
          </Card>
          <Card
            type="inner"
            title={t('ImpSumUpOpts.factualBasis')}
            style={{ marginTop:12 }}
            extra={(
              <Icon
                iconType={ANNOUNCEMENT}
                height="18"
                width="18"
                fill={BLACK}
              />
)}
          >
            {factualBasis ?? t('NoData')}
          </Card>
          <Card
            type="inner"
            title={t('ImpSumUpOpts.auto')}
            style={{ marginTop:12 }}
            extra={(
              <>
                <RobotOutlined />
                {' '}
                <strong>AI</strong>
              </>
)}
          >
            {shouldAutoAssign ? t('Yes') : t('No')}
          </Card>
        </Card>
      </Col>
    </RowMd>
  );
};

export default ImpSumUpOpts;